import type { CellConfig } from './types'

export function padRow(
  row: CellConfig[],
  mode: 'prepend' | 'append' | 'fill',
  decoration: boolean = true,
  count = 10,
): CellConfig[] {
  const pad: CellConfig[] = Array.from({ length: count }, () =>
    decoration ? { track: 'WE', decoration: true } : null,
  )
  if (mode === 'prepend') return [...pad, ...row]
  if (mode === 'append') return [...row, ...pad]
  return [...pad, ...row, ...pad]
}
